<template>
  <v-dialog
    v-model="dialog"
  >
    <v-card>
      <v-card-text v-if="loading" class="text-center">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        />
      </v-card-text>
      <v-card-text v-else>
        <apexchart type="bar" :height="350" :options="chartOptions" :series="series" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import helper from '../../../plugins/helpers/mixin-helper';
export default {
  mixins: [
    helper
  ],
  props: {
    ui: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      dialog: true,
      loading: true,
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          height: 350,
        },
        title: {
          text: 'Equiped weapons by Tension Beats'
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            formatter: (value) => this.timeToString(value)
          }
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            dataLabels: {
              total: {
                enabled: true,
                formatter: (value) => this.timeToString(value),
                style: {
                  fontSize: '13px',
                  fontWeight: 900,
                },
              },
            },
          },
        },
      }
    }
  },
  watch: {
    dialog (val) {
      if (!val) {
        setTimeout(() => {
          this.$emit('close')
        }, 500)
      }
    },
    async '$route.params' () {
      await this.getData()
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/global-equiped-weapon/tension-beats/chart`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.series = data.series
        this.chartOptions = {
          ...this.chartOptions,
          xaxis: {
            categories: data.tensionBeats
          }
        }
      }
      this.loading = false
    }
  }
}
</script>